// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__2EGTS","paramInput":"JobSimulator_paramInput__2HVnp","input":"JobSimulator_input__hoRuv"};